import { UsdPriceServiceAbstract } from '@cronos-app/swap-sdk';
import { BASE_USD_TOKEN_BY_CHAIN } from '../configs/token';
import { H2Lp__factory } from '../contracts';
import { lpListFetcher } from '../fetchers/lpListFetcher';
import { tokenListFetcher } from '../fetchers/tokenListFetcher';
import { getContract } from '../utils/getContract';
import { toWrappedTokenFactory } from '../utils/toWrappedTokenFactory';
export class UsdPriceService extends UsdPriceServiceAbstract {
    constructor(chainId) {
        super(BASE_USD_TOKEN_BY_CHAIN[chainId]);
        this.chainId = chainId;
        this.getLpPairs = () => pipeLpList(this.chainId);
        this.toWrappedToken = toWrappedTokenFactory(this.chainId);
        this.getToken0 = (address) => getContract(this.chainId, address, H2Lp__factory.abi).token0();
        this.getToken1 = (address) => getContract(this.chainId, address, H2Lp__factory.abi).token1();
        this.getReserves = (address) => getContract(this.chainId, address, H2Lp__factory.abi).getReserves();
    }
}
const pipeLpList = async (chainId) => {
    const tokenList = await tokenListFetcher(chainId);
    const lpList = await lpListFetcher(chainId);
    const tokenSet = new Set(tokenList.map((t) => t.address.toLowerCase()));
    return lpList
        .map((lp) => {
        if (!tokenSet.has(lp.token.address.toLowerCase()) ||
            !tokenSet.has(lp.quoteToken.address.toLowerCase()))
            return;
        return {
            token: lp.token,
            quoteToken: lp.quoteToken,
            address: lp.lpAddress,
        };
    })
        .filter((lp) => !!lp);
};
